import { Navigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { SUPER_ADMIN } from "../../Services/enum";

export const MasterAuthGuard = ({ component }) => {
    const UserData = localStorage.getItem("qtrackuser") && JSON.parse(localStorage.getItem("qtrackuser"))
    const Role = UserData?.user?.Role
    
    return (
        Role === SUPER_ADMIN
        ?
         component 
        :
         !Role
        ? 
        <Navigate to="/Login" />
        :
        <Navigate to="/" />
    )
}

MasterAuthGuard.prototype = {
    component: PropTypes.element,
}